import { lazy } from 'react';

const CustomPlanificationsReportSearcherCartera = lazy(() => import('./CustomPlanificationsReportSearcherCartera'));

export default CustomPlanificationsReportSearcherCartera;
